import { createUseSquadsMultisig } from "@solomon-apps/shared";

import { preflightMultisig } from "@/services/clientPositions";

/**
 * The debounce/poll/cache machinery lives in
 * `@solomon-apps/shared` (`createUseSquadsMultisig`) and is shared with the
 * issuer console; this module binds it to the client preflight endpoint and
 * re-exports the helpers so existing imports keep working.
 */
export const useSquadsMultisig = createUseSquadsMultisig(preflightMultisig);

export {
    deriveSignerStatus,
    extractSquadsMultisigAddress,
    isCacheablePreflightResult,
    isMemberCannotVerify,
    isVerifyMember,
    mapPreflightResponse,
    pollPreflightUntilSettled
} from "@solomon-apps/shared";
export type {
    SquadsMultisigInfo,
    SquadsMultisigMember,
    SquadsMultisigStatus,
    SquadsSignerStatus
} from "@solomon-apps/shared";
